import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import {getTag} from "../../../actions/tagActions";
import QuestionViewerExpandableHook from "../questions/QuestionViewerExpandableHook";
import ArgoReviewTemplateHook from "../../common/ArgoReviewTemplateHook";
import * as TEMPLATE from "../../../constants/templateConstants";

function TagReviewHook({ id, width }) {
    // State hooks
    const [openQuestionReview, setOpenQuestionReview] = useState(false);
    const [selectedQuestionInfoId, setSelectedQuestionInfoId] = useState("");
    const [selectedQuestionInfoKey, setSelectedQuestionInfoKey] = useState("");
    const [selectedQuestionInfoTemplate, setSelectedQuestionInfoTemplate] = useState("");

    // Redux hooks
    const dispatch = useDispatch();
    const templateFromRedux = useSelector(state => state.tag && state.tag.hasOwnProperty(id) ? state.tag[id] : null);
    const template = templateFromRedux !== null ? templateFromRedux : {};

    // Effects
    useEffect(() => {
        if (id) {
            dispatch(getTag(id));
        }
    }, [id, dispatch]);

    // Event handlers
    const setStateCallback = (stateObj) => {
        if ('openQuestionReview' in stateObj) setOpenQuestionReview(stateObj.openQuestionReview);
        if ('selectedQuestionInfoId' in stateObj) setSelectedQuestionInfoId(stateObj.selectedQuestionInfoId);
        if ('selectedQuestionInfoKey' in stateObj) setSelectedQuestionInfoKey(stateObj.selectedQuestionInfoKey);
        if ('selectedQuestionInfoTemplate' in stateObj) setSelectedQuestionInfoTemplate(stateObj.selectedQuestionInfoTemplate);
    };

    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        switch (buttonTitle) {
            case "BACK":
                // Used on info icon button from question accordions
                setOpenQuestionReview(false);
                break;
            // no default
        }
        event.preventDefault(); // Fix for the enter key propagating to the next focusable element
    };

    if (openQuestionReview) {
        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.QUESTION}
            templateId={selectedQuestionInfoId}
            templateKey={selectedQuestionInfoKey}
            selectedTemplate={selectedQuestionInfoTemplate}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={width}
        />;
    }

    return (
        template.hasOwnProperty("questionKeys") ?
            <div id="tag-viewer-container-div" style={{padding: "30px"}}>

                <Typography variant="h6" component="div">
                    Tag Information:
                </Typography>

                <div>&nbsp;</div>

                <div style={{display: "flex", width: "40%"}}>
                    <div id="tag-viewer-label-div" style={{float: "left", paddingBottom: "12px", fontSize: "20px", color: "silver"}}>Name:</div>

                    <div id="tag-viewer-spacer1-div" style={{float: "left", width: "20px"}}></div>

                    <div id="tag-viewer-name-div" style={{float: "left", paddingBottom: "12px", fontSize: "20px", fontWeight: "500"}}>{template.name}</div>

                </div>

                {/*// ===========================================================================================================*/}
                {/*// ASSIGNED QUESTIONS LIST */}
                {/*// ===========================================================================================================*/}

                <QuestionViewerExpandableHook
                    parentName={"TagReview"}
                    parentType={TEMPLATE.TYPE.TAG}
                    parentTemplate={template}
                    questionKeys={template.questionKeys}
                    showIconButtonReorder={false}
                    showIconButtonEdit={false}
                    showIconButtonRemove={false}
                    setStateCallback={setStateCallback}
                />

            </div>
            : ""
    );
}

TagReviewHook.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.string
};

export default TagReviewHook;
